import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import UserStore from 'stores/UserStore';

const UserBadge = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 12px;

  && .ant-avatar {
    margin-right: 8px;
  }
`;

const SelectedUsers = observer(({ selectedUsers = [] }) => {
  return (
    <div>
      {selectedUsers.map((userId) => (
        <UserBadge key={userId}>
          <Avatar shape="square" icon={<UserOutlined />} />
          <span>{UserStore.data.get(userId).name}</span>
        </UserBadge>
      ))}
      {selectedUsers.length === 0 && <p>None Selected</p>}
    </div>
  );
});

SelectedUsers.propTypes = {
  selectedUsers: PropTypes.array,
};

SelectedUsers.defaultProps = {
  selectedUsers: [],
};

export default SelectedUsers;
